import React, { useCallback } from 'react';
import { Wrapper, Title, Subtitle, Description, TagsRow, Tags } from './styled';
import { useLocale } from 'locale';
import { SmallText } from 'ds/components/typography';
import { Tag } from '../Tag';
import { CityDropdown } from '../CityDropdown';
import { useSelector } from 'react-redux';
import { madadParticipantsFilterData } from 'store/state/domainData/selectors/madadParticipants';
import { Route, useRoute } from 'config/routes';
import { useSendEvent } from 'analytics/useSendEvent';

const hotAreas: Array<{ id: string; label: string }> = [
  {
    id: 'תל-אביב-יפו-מרכז',
    label: 'תל אביב יפו - מרכז',
  },
  {
    id: 'חיפה-ישראל',
    label: 'חיפה',
  },
  {
    id: 'ירושלים-ישראל',
    label: 'ירושלים',
  },
  {
    id: 'עמק-יזרעאל-והסביבה',
    label: 'עמק יזראל והסביבה',
  },
  {
    id: 'רעננה-ישראל',
    label: 'רעננה',
  },
];

interface HeroProps {
  heroRef: React.RefObject<HTMLDivElement>;
}

export const Hero: React.FC<HeroProps> = (props) => {
  const { heroRef } = props;
  const { t } = useLocale();
  const filterRecords = useSelector(madadParticipantsFilterData);
  const { router } = useRoute();
  const sendEvent = useSendEvent();

  const handleCityClick = (docId: string) => {
    router.navigate(docId ? Route.MadadCity : Route.MadadPage, {
      id: docId,
    });
  };

  const handleDropdownOpen = useCallback(() => {
    sendEvent('madad_search_interaction', 'madad', {
      event: { action_type: 'dropdown_open' },
    });
  }, [ sendEvent ]);

  const handleOptionSelect = useCallback((label: string) => {
    sendEvent('madad_search_interaction', 'madad', {
      event: { action_type: 'option_select', filter_value: label },
    });
  }, [ sendEvent ]);

  const handleQuickFilterClick = useCallback((label: string) => {
    sendEvent('madad_search_interaction', 'madad', {
      event: { action_type: 'quick_filter', filter_value: label },
    });
  }, [ sendEvent ]);

  return (
    <Wrapper ref={heroRef}>
      <Title weight="bold">{t('madad.2026.title')}</Title>
      <Subtitle>{t('madad.2026.year')}</Subtitle>
      <Description dangerouslySetInnerHTML={{ __html: t('madad.2026.subtitle') }} />
      <CityDropdown
        onChange={handleCityClick}
        filterRecords={filterRecords}
        onDropdownOpen={handleDropdownOpen}
        onOptionSelect={handleOptionSelect}
      />
      <TagsRow>
        <SmallText>{t('madad.2026.hot.title')}</SmallText>
        <Tags>
          {hotAreas.map((area) => (
            <Tag key={area.id} id={area.id} onClick={() => handleQuickFilterClick(area.label)}>{area.label}</Tag>
          ))}
        </Tags>
      </TagsRow>
    </Wrapper>
  );
};
